import {Locales} from '@netx/core-next/locales/utils/Locales';

export const FormLabel = Locales((i18n) => ({
	SUBMIT: i18n('i18n.submit'),
}));
